module.exports = __webpack_public_path__ + "static/media/locator.82d82868.svg";